<template>
  <v-app>
    <v-app-bar id="apptoolbar" app color="primary" dark>

      <div class="d-flex align-center">
        <span>Rainy Season</span>
      </div>

      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
         <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="setViewType(0)">
            <v-list-item-title class="text-left"><v-icon :color="getCheckmark(0)">mdi-check</v-icon>Rainy Only View</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setViewType(1)">
            <v-list-item-title class="text-left"><v-icon :color="getCheckmark(1)">mdi-check</v-icon>Standard View</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setViewType(2)">
            <v-list-item-title class="text-left"><v-icon :color="getCheckmark(2)">mdi-check</v-icon>Enhanced View</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
           <v-list-item @click="$refs.tableview.collapseAll()">
            <v-list-item-title class="text-left">Collapse All</v-list-item-title>
          </v-list-item>
           <v-list-item @click="$refs.tableview.expandAll()">
            <v-list-item-title class="text-left">Expand All</v-list-item-title>
          </v-list-item>
           <v-list-item @click="$refs.tableview.filterMyLocations()">
            <v-list-item-title class="text-left">Show Favorites Only</v-list-item-title>
          </v-list-item>        
           <v-list-item @click="$refs.tableview.showAllLocations()">
            <v-list-item-title class="text-left">Show All Locations</v-list-item-title>
          </v-list-item>                 
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-content>
      <TableView ref="tableview"> </TableView>
    </v-content>

  </v-app>
</template>

<script>
import TableView from "./components/TableView.vue";

export default {
  name: "App",

  components: {
    TableView
  },

  data: () => ({
    viewType: 0             // 0 = parameterView / 1 = standard view / 2 = enhanced view
  }),
  mounted: function () {
    this.$refs.tableview.setViewType(this.viewType);
  },
  methods: {
    setViewType: function(vT) {
      this.viewType = vT;
      this.$refs.tableview.setViewType(vT);
    },
    getCheckmark: function(menuitem) {
      var color='';

      (menuitem == this.viewType) ? color = 'gray' : color = 'transparent';

      return color;
    }
  }
};
</script>
